import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as userActions from "../../actions/userActions";
import * as constants from "../../constants";

const createUserLogic = createLogic({
	type: ActionTypes.CREATE_USER,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.post(
					"/users",
					Object.assign({}, action.data, {
						firebaseUserId: getState().auth.user.uid,
					})
				)
					.then(() => {
						dispatch(userActions.getUser());
						done();
					})
					.catch(error => {
						dispatch(userActions.getUserFail(error));
						done();
					});
			});
	},
});

export default [createUserLogic];
